export default __webpack_public_path__ + "static/media/157.3aaad26a.png";